module.exports = __webpack_public_path__ + "img/DNARepair-ASHN_GSE227469.0d8d84da.png";